module.exports = {
  buildVersion: "0.1.1",
  buildDate: 1698922649465,
}